export const DEFAULT_PAGE = 1
export const DEFAULT_PAGE_SIZE = 5

export const PAGE_SIZE_OPTIONS = [5, 10, 20, 50, 100]
